(function () {
  'use strict';

  angular.module('sempraWebapp').service('doserSubsystemUtils', doserSubsystemUtilsService);

  /** @ngInject */
  function doserSubsystemUtilsService (modelUtils, PointTypeEnum) {
    var that = this;

    this.getDoserSubsystemPoint = function (facilityJson) {
      return facilityJson.points.find(function (pointJson) {
        return pointJson.pointType === PointTypeEnum.SUBSYSTEM
          && pointJson.name === PointTypeEnum.properties.NAMES.DOSER;
      });
    };

    this.getFeedValue = function (pointJson, feedReference) {
      return that.FeedReferences.properties[feedReference].getValue(pointJson);
    };

    this.getFeed = function (pointJson, feedReference) {
      return that.FeedReferences.properties[feedReference].getFeed(pointJson);
    };

    this.getActuatorValue = function (pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getValue(pointJson);
    };

    this.getActuator = function (pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getActuator(pointJson);
    };

    this.FeedReferences = Object.freeze({
      OP_CRPKA_PRASKA_GRE_MZS: 'OP_CRPKA_PRASKA_GRE_MZS',
      OP_DOZATOR_PRASKA_GRE_MZS: 'OP_DOZATOR_PRASKA_GRE_MZS',
      OP_VIBRATOR_PRASKA_GRE_MZS: 'OP_VIBRATOR_PRASKA_GRE_MZS',
      OP_MIN_PRASAK_TON_ALARM: 'OP_MIN_PRASAK_TON_ALARM',
      OP_MAX_NIVO_PRASAK: 'OP_MAX_NIVO_PRASAK',
      OP_MIN_NIVO_PRASAK: 'OP_MIN_NIVO_PRASAK',
      OP_CRPKA_PRASKA_RAD: 'OP_CRPKA_PRASKA_RAD',
      OP_DOZATOR_PRASKA_RAD: 'OP_DOZATOR_PRASKA_RAD',
      OP_EMV_SPREMNIK_PRASKA: 'OP_EMV_SPREMNIK_PRASKA',
      OP_BUTTON_11M4_BR_RESET: 'OP_BUTTON_11M4_BR_RESET',
      OP_CPR_11M4_BROJ_SATI_RADA: 'OP_CPR_11M4_BROJ_SATI_RADA',
      properties: {
        OP_CRPKA_PRASKA_GRE_MZS: getFeedPropertiesObject('OP_CRPKA_PRASKA_GRE_MZS'),
        OP_DOZATOR_PRASKA_GRE_MZS: getFeedPropertiesObject('OP_DOZATOR_PRASKA_GRE_MZS'),
        OP_VIBRATOR_PRASKA_GRE_MZS: getFeedPropertiesObject('OP_VIBRATOR_PRASKA_GRE_MZS'),
        OP_MIN_PRASAK_TON_ALARM: getFeedPropertiesObject('OP_MIN_PRASAK_TON_ALARM'),
        OP_MAX_NIVO_PRASAK: getFeedPropertiesObject('OP_MAX_NIVO_PRASAK'),
        OP_MIN_NIVO_PRASAK: getFeedPropertiesObject('OP_MIN_NIVO_PRASAK'),
        OP_CRPKA_PRASKA_RAD: getFeedPropertiesObject('OP_CRPKA_PRASKA_RAD'),
        OP_DOZATOR_PRASKA_RAD: getFeedPropertiesObject('OP_DOZATOR_PRASKA_RAD'),
        OP_EMV_SPREMNIK_PRASKA: getFeedPropertiesObject('OP_EMV_SPREMNIK_PRASKA'),
        OP_BUTTON_11M4_BR_RESET: getFeedPropertiesObject('OP_BUTTON_11M4_BR_RESET'),
        OP_CPR_11M4_BROJ_SATI_RADA: getFeedPropertiesObject('OP_CPR_11M4_BROJ_SATI_RADA')
      }
    });

    this.ActuatorReferences = Object.freeze({
      OP_PRASAK_VRIJEME_RADA: 'OP_PRASAK_VRIJEME_RADA',
      OP_PRASAK_VRIJEME_PAUZE : 'OP_PRASAK_VRIJEME_PAUZE',  // DOSER PAUSE TIME (SEC)
      properties: {
        OP_PRASAK_VRIJEME_RADA: getActuatorPropertiesObject('OP_PRASAK_VRIJEME_RADA'),
        OP_PRASAK_VRIJEME_PAUZE: getActuatorPropertiesObject('OP_PRASAK_VRIJEME_PAUZE')
      }
    });

    function getFeedPropertiesObject (feedReference) {
      return {
        getValue: function (facilityPointJson) {
          return modelUtils.getFeedCurrentValue(facilityPointJson, feedReference);
        },
        getFeed: function (facilityPointJson) {
          return modelUtils.getFeed(facilityPointJson, feedReference);
        }
      }
    }

    function getActuatorPropertiesObject (actuatorReference) {
      return {
        getValue: function (facilityPointJson) {
          return modelUtils.getActuatorCurrentValue(facilityPointJson, actuatorReference);
        },
        getActuator: function (facilityPointJson) {
          return modelUtils.getActuator(facilityPointJson, actuatorReference);
        }
      }
    }

  }
})();
